import { IconButton } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

export const Expander = ({ expanded, onClick, color }) => {
	return (
		<IconButton
			sx={{
				alignSelf: 'flex-end',
				background: 'inherit',
				'&:hover': {
					background: 'transparent'
				},
				color: color,
				'@container course-info (min-width: 0) and (max-width: 500px)': {
					padding: '.5rem 1rem .5rem 1rem',
				},
				padding: '0.9rem 1rem 0.9rem 5rem',
			}}
			onClick={onClick}
		>
			<ExpandMore
				titleAccess='Alle Informationen anzeigen'
				aria-expanded={expanded}
				sx={{
					fontSize: '2rem',
					transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
					transition: 'transform'
				}}
			/>
		</IconButton>
	);
};